import { render } from "./brandEdit.vue?vue&type=template&id=28a239ff&scoped=true"
import script from "./brandEdit.vue?vue&type=script&lang=js"
export * from "./brandEdit.vue?vue&type=script&lang=js"

import "./brandEdit.vue?vue&type=style&index=0&id=28a239ff&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a239ff"],['__file',"src/views/brand/brandEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28a239ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28a239ff', __exports__)) {
    console.log('reload')
    api.reload('28a239ff', __exports__)
  }
  
  module.hot.accept("./brandEdit.vue?vue&type=template&id=28a239ff&scoped=true", () => {
    console.log('re-render')
    api.rerender('28a239ff', render)
  })

}


export default __exports__